export enum UserFollowedDataObjectGroupUrl {
  base = '/user-followed-data-object-group{/id}{?page,size,sort*,dataObjectGroup}',
}
